'use strict';

var styleInject_es = require('../../../../node_modules/style-inject/dist/style-inject.es.js');

var css_248z = ".varta-page-title {\n  color: #8a92a2;\n  font-size: 16px;\n  text-transform: uppercase;\n  font-weight: 200;\n  line-height: 1.3em;\n  text-align: center;\n  border-bottom: 1px solid #d2d8dd;\n  margin: 0 -20px 50px -20px;\n  padding: 17px 20px 12px 20px; }\n  @media (min-width: 1024px) {\n    .varta-page-title {\n      display: none; } }\n";
styleInject_es(css_248z);
